import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

const GOLD         = "#C9A96E";
const GOLD_PALE    = "#F0DEB4";
const GOLD_BG      = "#FEF9EE";
const INK          = "#1C1915";
const INK_SOFT     = "#4A4540";
const INK_MUTED    = "#9A9390";
const BORDER       = "#E7E1D8";
const SOFT_BG      = "#F7F5F2";
const WHITE        = "#FFFFFF";
const GREEN        = "#1A7A44";
const GREEN_BG     = "#E8F6EF";
const GREEN_BORDER = "#B2DEC8";

function fmtMAD(n) {
  if (!n && n !== 0) return "—";
  return Number(n).toLocaleString("fr-FR") + " MAD";
}

export default function ListePrequalificationsPage({ setActiveTab, cabinetId = null }) {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creatingId, setCreatingId] = useState(null);

  useEffect(() => {
    if (cabinetId == null) return;
    charger();
  }, [cabinetId]);

  async function charger() {
    setLoading(true);
    const { data } = await supabase
      .from("prospects")
      .select("*")
      .eq("cabinet_id", cabinetId)
      .order("created_at", { ascending: false });
    if (data) setLeads(data);
    setLoading(false);
  }

  async function creerProjet(lead) {
    setCreatingId(lead.id);
    const nomClient = [lead.prenom, lead.nom].filter(Boolean).join(" ") || "Client";
    const typeProjet = lead.type_projet || "Projet";
    const nomProjet = `${typeProjet} — ${nomClient}`;
    const description = [
      lead.zone_souhaitee ? `Zone : ${lead.zone_souhaitee}` : null,
      lead.delai ? `Délai : ${lead.delai}` : null,
      lead.notes ? `Notes : ${lead.notes}` : null,
    ].filter(Boolean).join("\n");

    const { data: projet, error } = await supabase
      .from("projects")
      .insert([{
        name: nomProjet,
        client_name: nomClient,
        status: "diagnostic",
        budget: lead.budget_min || null,
        progress: 0,
        description: description || null,
        cabinet_id: cabinetId,
      }])
      .select()
      .single();

    setCreatingId(null);
    if (error) {
      alert("Erreur création projet : " + error.message);
      return;
    }
    if (setActiveTab) setActiveTab("projets:" + projet.id);
  }

  async function transformerEnProjet(lead) {
    setCreatingId(lead.id);
    const nomClient = [lead.prenom, lead.nom].filter(Boolean).join(" ") || "Client";
    const typeProjet = lead.type_projet || "Projet";
    const nomProjet = `${typeProjet} — ${nomClient}`;
    const description = lead.notes ? lead.notes.trim() : null;

    const { data: projet, error } = await supabase
      .from("projects")
      .insert([{
        name: nomProjet,
        client_name: nomClient,
        status: "diagnostic",
        budget: lead.budget_min || null,
        progress: 0,
        description: description,
        cabinet_id: cabinetId,
      }])
      .select()
      .single();

    if (error) {
      setCreatingId(null);
      alert("Erreur création projet : " + error.message);
      return;
    }

    await supabase.from("prospects").update({ statut: "converti" }).eq("id", lead.id);
    setLeads((prev) => prev.map((l) => (l.id === lead.id ? { ...l, statut: "converti" } : l)));
    setCreatingId(null);
    if (setActiveTab) setActiveTab("projets:" + projet.id);
  }

  if (cabinetId == null) {
    return <div style={{ padding: 24, textAlign: "center", color: INK_MUTED }}>Chargement...</div>;
  }

  return (
    <div style={{ fontFamily: "system-ui, sans-serif", color: INK, maxWidth: 1100, margin: "0 auto" }}><div style={{ marginBottom: 24 }}><div style={{ fontSize: 10, letterSpacing: "0.18em", textTransform: "uppercase", color: GOLD, fontWeight: 700, marginBottom: 4 }}>
          YOMA DESIGN — Entrée
        </div><div style={{ fontSize: 22, fontWeight: 800, color: INK }}>Liste des préqualifications</div><div style={{ fontSize: 12, color: INK_MUTED, marginTop: 4 }}>
          {leads.length} lead{leads.length !== 1 ? "s" : ""} enregistré{leads.length !== 1 ? "s" : ""}
        </div></div>

      {loading ? (
        <div style={{ padding: 48, textAlign: "center", color: INK_MUTED, fontSize: 13 }}>
          Chargement…
        </div>
      ) : leads.length === 0 ? (
        <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "48px 24px", textAlign: "center" }}><div style={{ fontSize: 32, marginBottom: 12 }}>—</div><div style={{ fontSize: 14, fontWeight: 600, color: INK, marginBottom: 6 }}>Aucun lead</div><div style={{ fontSize: 12, color: INK_MUTED }}>Les leads sont enregistrés depuis la page Préqualification.</div></div>
      ) : (
        <div style={{ background: WHITE, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}><div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr auto auto", gap: 12, padding: "14px 20px", background: GOLD_BG, borderBottom: `1px solid ${GOLD_PALE}`, fontSize: 10, letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 700, color: INK_SOFT }}><div>Nom du client</div><div>Type de projet</div><div>Budget</div><div>Score</div><div style={{ textAlign: "right" }}>Action</div></div>
          {leads.map((p) => {
            const nomClient = [p.prenom, p.nom].filter(Boolean).join(" ") || "—";
            const isCreating = creatingId === p.id;
            return (
              <div
                key={p.id}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr auto auto",
                  gap: 12,
                  alignItems: "center",
                  padding: "14px 20px",
                  borderBottom: `1px solid ${BORDER}`,
                  fontSize: 13,
                }}
              ><div style={{ fontWeight: 600, color: INK }}>{nomClient}</div><div style={{ color: INK_SOFT }}>{p.type_projet || "—"}</div><div style={{ color: INK_SOFT }}>{fmtMAD(p.budget_min)}</div><div>
                  {p.score != null ? (
                    <span style={{ fontSize: 12, fontWeight: 700, color: GREEN, background: GREEN_BG, border: `1px solid ${GREEN_BORDER}`, borderRadius: 999, padding: "3px 10px" }}>
                      {p.score}
                    </span>
                  ) : (
                    <span style={{ color: INK_MUTED }}>—</span>
                  )}
                </div><div style={{ textAlign: "right" }}>
                  {p.statut === "converti" ? (
                    <span style={{ fontSize: 11, fontWeight: 700, color: INK_MUTED }}>Converti</span>
                  ) : (p.score != null && p.score >= 10) ? (
                    <button
                      onClick={() => transformerEnProjet(p)}
                      disabled={isCreating}
                      style={{
                        padding: "8px 16px",
                        background: isCreating ? "#DDD" : GREEN,
                        border: "none",
                        borderRadius: 8,
                        fontSize: 12,
                        fontWeight: 700,
                        color: WHITE,
                        cursor: isCreating ? "not-allowed" : "pointer",
                      }}
                    >
                      {isCreating ? "Création…" : "Transformer en projet"}
                    </button>
                  ) : (
                    <button
                      onClick={() => creerProjet(p)}
                      disabled={isCreating}
                      style={{
                        padding: "8px 16px",
                        background: isCreating ? "#DDD" : GOLD,
                        border: "none",
                        borderRadius: 8,
                        fontSize: 12,
                        fontWeight: 700,
                        color: WHITE,
                        cursor: isCreating ? "not-allowed" : "pointer",
                      }}
                    >
                      {isCreating ? "Création…" : "Créer projet"}
                    </button>
                  )}
                </div></div>
            );
          })}
        </div>
      )}
    </div>
  );
}
